import SmoothScroll from 'smooth-scroll';

const scroll = () => {
  new SmoothScroll('a[href*="#"][data-scroll]', {
    speed: 500,
    updateURL: false,
  });
};

scroll();
